export enum TimelineEventVisibility {
    PUBLIC,
    ADMIN,
    USER,
}

export enum TimelineEventVariants {
    NONE = 'none',
    INFO = 'info',
    SHADE = 'shade',
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error',
    DECO_ONE = 'deco-one',
    DECO_TWO = 'deco-two',
}
